/**
 * SPDX-License-Identifier: MIT
 * Copyright (c) 2026 Solvetia. Original work by Solvetia — part of the Solvetia
 * white-label additions to Chatwoot Community Edition (MIT). Not derived from
 * the commercial code under enterprise/.
 */
/* global axios */
import ApiClient from './ApiClient';

class BrandingAPI extends ApiClient {
  constructor() {
    super('branding', { accountScoped: true });
  }

  update(formData) {
    return axios.patch(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new BrandingAPI();
